<div class="photoProduct">
  @if (product?.composedImages.length) {
    <lib-composed-images-drawer
      (configPicked)="preConfig.next($event)"
      [images]="$safeNavigationMigration(product?.composedImages)"
      [selectPhoto]="configuration | async"
    ></lib-composed-images-drawer>
  }
</div>
<div class="information">
  <ng-scrollbar>
    @if (!product.hasWizard) {
      <div class="allList">
        <h1>{{ product?.name }}</h1>
        @if (product.description | langPicker | async) {
          <p class="description">
            <mat-dialog-content
              [innerHTML]="product.description | langPicker | async"
              class="ql-editor">
            </mat-dialog-content>
          </p>
        }
        <lib-config-drawer
          (invalidFields)="invalidFields$.next($event)"
          (updated)="configuration.next($event)"
          [config]="$safeNavigationMigration(product?.config)"
          [preConfig]="preConfig | async"
          [preUpdated]="preConfiguration"
          [fixingAttributes]="fixingAttributes"
          [hideImageRelatedCounters]="true"
          (_filtered)="filtered.next($event)"
        ></lib-config-drawer>
        <h3 translate>clhsx7tgd000008lb94fe9zuh</h3>
        <app-change-number
          [(ngModel)]="quantity"
          [maxNumber]="999"
          [minNumber]="1"
        ></app-change-number>
        @if (images.imagesRequired) {
          <div>
            <h3>
              <span translate>numberRequiredPhotos</span>
              @if (images.requiredImages.min !== images.requiredImages.max) {
                <span
                translate>clhosyo3h000208msg4bdenyp</span>
              }
              {{ images.requiredImages.min }}
              @if (images.requiredImages.min !== images.requiredImages.max) {
                <span translate>clhosj3zm000208lb8eqgbzn5</span>
                {{ images.requiredImages.max }}
              }
            </h3>
          </div>
        }
      </div>
    }
  </ng-scrollbar>
  <div class="buttons">
    <ng-container *libIsHandset="desktop">
      <div>
        @if (product?.showDeliveryTime) {
          <h3>
            <span translate>clhswq9lt000008mf96czgebr</span> {{ product | timeToDeliveryWithConfigParser: (configuration | async) }}
          </h3>
        }
        @if (!product?.showDeliveryTime) {
          <h3></h3>
        }
        <h3>
          <span translate>clhswqfv5000108mf6y3zhpnr</span> {{ (product | priceWithConfigParser: (configuration | async) : photoIdList :  'with file': quantity : selectedProductId) | async | pricePicker}}
        </h3>
      </div>
      <div>
        <span>
          <lib-button (click)="hideDialog.emit()" forceContext="common" translate>comeBack</lib-button>
        </span>
        <span #photoSelectButton>
          @if (images.imagesRequired) {
            <lib-button
              (click)="addMissingPhotos()"
              forceContext="productFront" translate>
            clhrmtvdu000008ms5f0a0b36</lib-button>
          }
        </span>
        @if (!swap) {
          <span>
            <lib-button (click)="addToBasket()" forceContext="productFront" translate>
            clhrdulje000008mqel629la6</lib-button>
          </span>
        }
        @if (swap) {
          <span #saveButton>
            <lib-button (click)="swapToBasket()" forceContext="productFront" translate>
            clhrduqrj000108mqerma9y8b</lib-button>
          </span>
        }
      </div>
    </ng-container>
    <ng-template #desktop>
      <div>
        @if (product?.showDeliveryTime) {
          <h2>
            <span translate>clhswq9lt000008mf96czgebr</span>  {{ product | timeToDeliveryWithConfigParser: (configuration | async) }}
          </h2>
        }
        @if (!product?.showDeliveryTime) {
          <h2></h2>
        }
        <h2>
          <span translate>clhswqfv5000108mf6y3zhpnr</span> {{ (product | priceWithConfigParser: (configuration | async) : photoIdList :  'with file': quantity : selectedProductId) | async | pricePicker}}
        </h2>
      </div>
      <div>
        <span #photoSelectButton>
          @if (images.imagesRequired) {
            <lib-button (click)="addMissingPhotos()" lg translate>
            clhrmtvdu000008ms5f0a0b36</lib-button>
          }
        </span>
        @if (!swap) {
          <span>
            <lib-button (click)="addToBasket()" lg forceContext="productFront" translate>
            clhrdulje000008mqel629la6</lib-button>
          </span>
        }
        @if (swap) {
          <span #saveButton>
            <lib-button (click)="swapToBasket()" lg forceContext="productFront" translate>
            clhrduqrj000108mqerma9y8b</lib-button>
          </span>
        }
      </div>
    </ng-template>
  </div>
</div>

<ng-template #message>
  <div class="message">
    <h2>
      <p translate>clhsxaraw000008jtfp8m3ilm</p>
      <p> <span translate>clhsxax9a000108jtg4ei136w</span></p>
    </h2>
    <div>
      <lib-button (click)="openPhotosList$.next(false)"
      forceContext="common" translate>comeBack</lib-button>
      <lib-button (click)="openPhotosList$.next(true)"
      forceContext="productFront" translate>clhsxbjbx000208jt2bwm626k</lib-button>
    </div>
  </div>
</ng-template>
<ng-template #messageAboutAddedToBasket>
  <div class="message">
    <div>
      <h2 translate>clht4xtq6000008laan3h5hjq</h2>
      <p></p>
    </div>
  </div>
</ng-template>
